module.exports = __webpack_public_path__ + "assets/img/index-partner35.5a5bb4b3.jpg";